(() => {
  const TEXT_VARIATION = '\uFE0E';
  const EMOJI_VARIATION = '\uFE0F';

  const arrowPattern = /([↗↘↙↖])[\uFE0E\uFE0F]?/g;

  const ignoredElements = new Set([
    'SCRIPT',
    'STYLE',
    'TEXTAREA',
    'INPUT',
    'SELECT',
    'OPTION',
    'NOSCRIPT',
    'CODE',
    'PRE'
  ]);

  const fixTextNode = (textNode) => {
    const parent = textNode.parentElement;

    if (!parent || ignoredElements.has(parent.tagName)) return;

    const originalText = textNode.nodeValue;

    if (!originalText || !/[↗↘↙↖]/.test(originalText)) return;

    const correctedText = originalText.replace(
      arrowPattern,
      (_, arrow) => `${arrow}${TEXT_VARIATION}`
    );

    if (correctedText !== originalText) {
      textNode.nodeValue = correctedText;
    }
  };

  const fixArrowsInside = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      fixTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE &&
        root.nodeType !== Node.DOCUMENT_NODE &&
        root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      ignoredElements.has(root.tagName)
    ) {
      return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    let currentNode;

    while ((currentNode = walker.nextNode())) {
      textNodes.push(currentNode);
    }

    textNodes.forEach(fixTextNode);
  };

  const initializeArrowFix = () => {
    fixArrowsInside(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          fixArrowsInside(node);
        });

        if (
          mutation.type === 'characterData' &&
          mutation.target.nodeType === Node.TEXT_NODE
        ) {
          fixTextNode(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('shopify:section:load', (event) => {
      fixArrowsInside(event.target);
    });

    document.addEventListener('fokus:cart:open', () => {
      window.requestAnimationFrame(() => {
        fixArrowsInside(document.body);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeArrowFix,
      { once: true }
    );
  } else {
    initializeArrowFix();
  }
})();